import { Recommendation, Recommendations } from './matching.types';

export const useRecommendationsTableDataSource = (data: Recommendations<Recommendation> | undefined) =>
  data?.items ?? [];
